import { createSlice } from '@reduxjs/toolkit';
import { ResetStagedShipmentState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { resetStagedShipmentThunk } from './thunks';

// Initial State
const initialState: ResetStagedShipmentState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const resetStagedShipmentSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    resetStagedShipment: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(resetStagedShipmentThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(resetStagedShipmentThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(resetStagedShipmentThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { resetStagedShipment } = resetStagedShipmentSlice.actions;
export * from './thunks';
export default resetStagedShipmentSlice.reducer;
